import type { ProductSearchItem } from "@kss/storefront-config"

export const searchProductHref = (item: ProductSearchItem) =>
  `/products/${encodeURIComponent(item.handle)}?variant=${encodeURIComponent(
    item.id
  )}`
